export default {
  ageCategory: {
    en: 'Age:',
  },
  skinType: {
    en: 'Skin type:',
  },
}
